import { allReviews } from "@/mocks/homeData";
import { GOOGLE_REVIEWS_LINK } from "@/pages/home/constants";
import {
  GOOGLE_RATING_LABEL,
  GOOGLE_REVIEW_COUNT_TEXT,
} from "@/pages/home/googleStats";
import Stars from "@/components/base/Stars";
import ReviewsCarousel from "@/pages/home/components/ReviewsCarousel";

interface ServiceReviewsProps {
  /** Optional line describing the service, shown under the heading. */
  subtitle?: string;
}

export default function ServiceReviews({ subtitle }: ServiceReviewsProps) {
  const fiveStarReviews = allReviews.filter(
    (review) =>
      ["google", "tripadvisor"].includes(review.source) && (review.rating ?? 5) === 5,
  );

  return (
    <section id="avaliacoes" className="relative py-6 md:py-14 bg-background-50 scroll-mt-16">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-[1500px] mx-auto">
          <div className="flex flex-col items-center text-center mb-4 md:mb-6 reveal">
            <span className="inline-flex items-center gap-1.5 text-[10px] md:text-xs font-semibold uppercase tracking-[0.2em] text-accent-700 mb-2">
              <i className="ri-google-fill text-sm" />
              Avaliações reais no Google e no TripAdvisor
            </span>
            <h2 className="font-heading text-lg md:text-3xl font-bold text-foreground-950 mb-2">
              O que nossos clientes dizem sobre os passeios em Capitólio
            </h2>
            <p className="text-xs md:text-sm text-foreground-600 max-w-xl mx-auto mb-3">
              {subtitle ??
                "Notas e comentários de quem já viveu o Lago de Furnas com a Eco Tour Turismo."}
            </p>
            <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  {GOOGLE_RATING_LABEL}
                </span>
                <Stars className="text-sm md:text-base" />
              </div>
              <span className="hidden sm:block w-px h-5 bg-background-300/70" />
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-semibold whitespace-nowrap">
                <i className="ri-map-pin-2-fill text-sm" />
                Eco Tour Turismo — Capitólio/MG
              </span>
              <span className="text-[11px] font-medium text-foreground-500">
                {GOOGLE_REVIEW_COUNT_TEXT}
              </span>
            </div>
          </div>

          <div className="reveal">
            <ReviewsCarousel reviews={fiveStarReviews} />
          </div>

          <div className="mt-3 md:mt-5 flex justify-center">
            <a
              href={GOOGLE_REVIEWS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-white text-[11px] md:text-sm font-bold uppercase tracking-wide hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-star-fill text-sm md:text-base text-accent-300" />
              Ver todas as avaliações no Google
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}